import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function hasDotValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const fieldValue = control.value;
		let result: ValidationErrors | null = null;

		if (!fieldValue.includes(".")) {
			result = { "hasDotNotValid": true };
		} else if (fieldValue.includes("@")) {
			const atIndex = fieldValue.indexOf("@");
			const dotIndex = fieldValue.indexOf(".", atIndex);

			if (dotIndex === -1 || dotIndex < atIndex + 2) {
				result = { "mailDotNotValid": true };
			}
		} else {
			result = null;
		}

		return result;
	};
}
